var render = function (_h,_vm) {var _c=_vm._c;return _c('tr',_vm._b({class:_vm.props.row.showCombined ? 'color-row' : ''},'tr',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }